import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../context/AuthContext';
import { FaTrash, FaEye, FaTimes, FaEnvelope, FaEnvelopeOpen } from 'react-icons/fa';

export default function AdminMessages() {
  useAuth();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedMessage, setSelectedMessage] = useState(null);

  useEffect(() => {
    fetchMessages();
  }, []);

  const fetchMessages = async () => {
    try {
      const res = await api.get('/contact');
      setMessages(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      toast.error('Mesajlar yuklenirken hata olustu');
    } finally {
      setLoading(false);
    }
  };

  const handleView = async (message) => {
    setSelectedMessage(message);
    if (!message.is_read) {
      try {
        await api.put(`/contact/${message.id}/read`);
        setMessages((prev) =>
          prev.map((m) => (m.id === message.id ? { ...m, is_read: true } : m))
        );
      } catch (err) {
        // silently fail
      }
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bu mesaji silmek istediginize emin misiniz?')) return;
    try {
      await api.delete(`/contact/${id}`);
      toast.success('Mesaj silindi');
      if (selectedMessage?.id === id) {
        setSelectedMessage(null);
      }
      fetchMessages();
    } catch (err) {
      toast.error('Silme sirasinda hata olustu');
    }
  };

  const unreadCount = messages.filter((m) => !m.is_read).length;

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const date = new Date(dateStr);
    return date.toLocaleDateString('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  if (loading) {
    return <div className="admin-loading">Yukleniyor...</div>;
  }

  return (
    <div>
      <div className="admin-card">
        <div className="admin-card-header">
          <h2>
            Mesajlar{' '}
            {unreadCount > 0 && <span className="unread-badge">{unreadCount}</span>}
          </h2>
        </div>

        <table className="admin-table">
          <thead>
            <tr>
              <th style={{ width: 30 }}></th>
              <th>Ad Soyad</th>
              <th>E-posta</th>
              <th>Konu</th>
              <th>Tarih</th>
              <th>Islemler</th>
            </tr>
          </thead>
          <tbody>
            {messages.length === 0 ? (
              <tr>
                <td colSpan="6" style={{ textAlign: 'center' }}>
                  Henuz mesaj yok
                </td>
              </tr>
            ) : (
              messages.map((message) => (
                <tr
                  key={message.id}
                  style={{
                    fontWeight: message.is_read ? 'normal' : '600',
                    background: message.is_read ? undefined : 'rgba(134, 205, 145, 0.05)',
                  }}
                >
                  <td>
                    {message.is_read ? (
                      <FaEnvelopeOpen style={{ color: '#aaa' }} />
                    ) : (
                      <FaEnvelope style={{ color: '#86CD91' }} />
                    )}
                  </td>
                  <td>{message.name}</td>
                  <td>{message.email}</td>
                  <td>{message.subject || '-'}</td>
                  <td>{formatDate(message.created_at)}</td>
                  <td>
                    <div className="actions">
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={() => handleView(message)}
                      >
                        <FaEye />
                      </button>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleDelete(message.id)}
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Message Detail Modal */}
      {selectedMessage && (
        <div className="admin-modal-overlay" onClick={() => setSelectedMessage(null)}>
          <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
            <div className="admin-modal-header">
              <h2>{selectedMessage.subject || 'Mesaj Detayi'}</h2>
              <button
                className="admin-modal-close"
                onClick={() => setSelectedMessage(null)}
              >
                <FaTimes />
              </button>
            </div>
            <div className="message-detail">
              <div className="meta">
                <span><strong>Gonderen:</strong> {selectedMessage.name}</span>
                <span><strong>E-posta:</strong> {selectedMessage.email}</span>
                {selectedMessage.phone && (
                  <span><strong>Telefon:</strong> {selectedMessage.phone}</span>
                )}
                <span><strong>Tarih:</strong> {formatDate(selectedMessage.created_at)}</span>
              </div>
              <div className="body">{selectedMessage.message}</div>
            </div>
            <div style={{ marginTop: 15, textAlign: 'right' }}>
              <button
                className="btn btn-danger"
                onClick={() => {
                  handleDelete(selectedMessage.id);
                }}
              >
                <FaTrash /> Mesaji Sil
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
